import { AlertTriangle, Plus } from 'lucide-react';
import PropTypes from 'prop-types';
import { constants } from '../../../lib/constants/constants';
import { Button } from '../Button/Button';
import { useTranslation } from 'react-i18next';

export const Nodata = ({
  title = constants.NO_DATA.DATA_FOUND,
  description,
  icon = <AlertTriangle />,
  showButton = false,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full w-full p-1 overflow-y-auto items-center justify-center bg gap-1.5">
      {icon && <span>{typeof icon === 'string' ? <img src={icon} /> : icon}</span>}
      <span className="font-semibold">
        {t('FALLBACK_SCREEN.NO')} {title}
      </span>
      <span className="text-sm text-muted">{description && description}</span>
      {showButton && (
        <Button size="sm" onClick={onClick}>
          {<Plus />}
          {t('INCIDENTS_PANEL.CREATE_INCIDENT')}
        </Button>
      )}
    </div>
  );
};

Nodata.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
};
